import React from 'react'
import Titre from '../Includes/Misc/Titre'
import FilterReset from '../Includes/Filter/FilterReset'
import HeuresToolbarContent from './HeuresToolbarContent'
import {
  useSelector
} from 'react-redux'
import {
  Toolbar
} from '@mui/material'

const HeuresToolbarDesktop = () => {
  const notification = useSelector(state => state.notifications.notification)
  return (
    <Toolbar>
      <Titre>Heures</Titre>
      {
        (notification === '')
          ? <HeuresToolbarContent/>
          : <FilterReset notification={true}/>
      }
    </Toolbar>
  )
}

export default HeuresToolbarDesktop
